const locale = {
	hours: "Hours",
	minutes: "Minutes",
	save: "save"
};

export default locale;